import classNames from 'classnames';
import moment from 'moment';
import { IconSizes, IconVariants } from '../components/foundations/Icon';
import { Icon } from '../components/widgets';
import TableCellActions from '../components/widgets/TableCellActions';
import TableCellText from '../components/widgets/TableCellText';
import AppsCell from './components/AppsCell';
import PartnersCell from './components/PartnersCell';
import css from './styles.css';
import { translationPrefix } from './utils';

const translationTablePrefix = `${translationPrefix}.TABLE_COLUMNS`;
const translationActionPrefix = `${translationPrefix}.ACTIONS`;

export const getActionComponentsConfigs = (onManagePermissions, onDelete, translate) => {
    const commonActionComponentProps = {
        size: IconSizes.SMALL,
        variant: IconVariants.LIGHT,
    };
    return [
        {
            ActionComponent: Icon,
            key: 'deleteMember',
            title: translate(`${translationActionPrefix}.DELETE`),
            tooltipText: translate(`${translationActionPrefix}.DELETE`),
            onClick: onDelete,
            shouldShow: row => row.deletable && !row.isMe,
            actionComponentProps: {
                ...commonActionComponentProps,
                name: 'trash',
            },
        },
        {
            ActionComponent: Icon,
            key: 'managePermissions',
            title: translate(`${translationActionPrefix}.MANAGE_PERMISSIONS`),
            tooltipText: translate(`${translationActionPrefix}.MANAGE_PERMISSIONS`),
            onClick: onManagePermissions,
            shouldShow: () => true,
            actionComponentProps: {
                ...commonActionComponentProps,
                name: 'edit',
            },
        },
    ];
};

export const getTableColumns = (sortConfig, onChangeSort, onManagePermissions, onDelete, pageLoaded, translate) => {
    const isLoading = !pageLoaded;
    const commonColumnConfig = {
        boldHeader: true,
        cellProps: {
            className: css.tableCell,
            isLoading,
        },
    };
    return [
        {
            ...commonColumnConfig,
            cellProps: {
                ...commonColumnConfig.cellProps,
                className: classNames(commonColumnConfig.cellProps.className, css.nameCell),
            },
            name: 'name',
            displayName: `${translationTablePrefix}.AGENCY_NAME`,
            cellComponent: TableCellText,
            headerWidth: '26%',
            showHeaderArrow: true,
            headerArrow: sortConfig.name === 'name' ? sortConfig.direction : null,
            headerClick: () => onChangeSort('name'),
        },
        {
            ...commonColumnConfig,
            displayName: `${translationTablePrefix}.APPS`,
            headerWidth: '26%',
            cellComponent: AppsCell,
            cellValues: [
                {
                    propName: 'appSitePublicIds',
                    dataKey: 'role',
                    transformation: role => role?.row.find(r => r.dimension === 'app_site_id')?.values || [],
                },
                {
                    propName: 'operator',
                    dataKey: 'role',
                    transformation: role => role?.row.find(r => r.dimension === 'app_site_id')?.operator || 'not in',
                },
            ],
        },
        {
            ...commonColumnConfig,
            displayName: `${translationTablePrefix}.PARTNERS`,
            cellComponent: PartnersCell,
            headerWidth: '26%',
            cellValues: [
                {
                    propName: 'baseSourceNames',
                    dataKey: 'role',
                    transformation: role => role?.row.find(r => r.dimension === 'base_source')?.values || [],
                },
                {
                    propName: 'operator',
                    dataKey: 'role',
                    transformation: role => role?.row.find(r => r.dimension === 'base_source')?.operator || 'not in',
                },
            ],
        },
        {
            ...commonColumnConfig,
            displayName: `${translationTablePrefix}.LAST_EDITED`,
            cellComponent: TableCellText,
            headerWidth: '15%',
            cellValues: [
                {
                    propName: 'value',
                    dataKey: 'role',
                    transformation: role => (role?.modified ? moment(role.modified).format('MMM DD, YYYY') : ''),
                },
            ],
            showHeaderArrow: true,
            headerArrow: sortConfig.name === 'modified' ? sortConfig.direction : null,
            headerClick: () => onChangeSort('modified'),
        },
        {
            ...commonColumnConfig,
            displayName: `${translationTablePrefix}.ACTIONS`,
            cellComponent: TableCellActions,
            cellProps: {
                ...commonColumnConfig.cellProps,
                className: classNames(commonColumnConfig.cellProps.className, css.actionCell, {
                    [css.actionCellLoader]: isLoading,
                }),
                actionComponentsConfigs: getActionComponentsConfigs(onManagePermissions, onDelete, translate),
            },
        },
    ];
};
